// extracted by mini-css-extract-plugin
export default {"inputContainer":"EnterId_inputContainer__Jm9sy","prompt":"EnterId_prompt__0XbjK"};